import { createBrowserRouter } from "react-router-dom";
import Layout from "../components/layout";
import AboutDark from "../pages/AboutDark";
import AboutLight from "../pages/AboutLight";
import AboutUs from "../pages/AboutUs";
import Blog from "../pages/Blog";
import BlogDark from "../pages/BlogDark";
import BlogDarkSidebar from "../pages/BlogDarkSidebar";
import BlogLight from "../pages/BlogLight";
import BlogLightSidebar from "../pages/BlogLightSidebar";
import Career from "../pages/Career";
import ComingSoon from "../pages/ComingSoon";
import Contact from "../pages/Contact";
import ContactDark from "../pages/ContactDark";
import ContactLight from "../pages/ContactLight";
import ErrorPage from "../pages/ErrorPage";
import Faq from "../pages/FAQ";
import Home from "../pages/Home";
import HomeFive from "../pages/HomeFive";
import HomeFour from "../pages/HomeFour";
import HomeThree from "../pages/HomeThree";
import HomeTwo from "../pages/HomeTwo";
import PortfolioOne from "../pages/PortfolioOne";
import PortfolioThree from "../pages/PortfolioThree";
import PortfolioTwo from "../pages/PortfolioTwo";
import PricingOne from "../pages/PricingOne";
import PricingTwo from "../pages/PricingTwo";
import Service from "../pages/Service";
import SingleBlogDark from "../pages/SingleBlogDark";
import SingleBlogLight from "../pages/SingleBlogLight";
import SingleCareer from "../pages/SingleCareer";
import SinglePortFolio from "../pages/SinglePortfolio";
import SingleService from "../pages/SingleService";
import SingleTeam from "../pages/SingleTeam";
import Team from "../pages/Team";
import TeamDark from "../pages/TeamDark";
import TeamLight from "../pages/TeamLight";
import Testimonial from "../pages/Testimonial";

const home = {
  header: "one",
  footer: "one",
}

const home2 = {
  header: "two",
  footer: "two",
}

const home3 = {
  header: "three",
  footer: "three",
}

const home4 = {
  header: "four",
  footer: "four",
}

const home5 = {
  header: "five",
  footer: "five",
}

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout>
      <Home {...home} />
    </Layout>,
  },
  {
    path: "/home-two",
    element: <Layout>
      <HomeTwo {...home2} />
    </Layout>,
  },
  {
    path: "/home-three",
    element: <Layout>
      <HomeThree {...home3} />
    </Layout>,
  },
  {
    path: "/home-four",
    element: <Layout>
      <HomeFour {...home4} />
    </Layout>,
  },
  {
    path: "/home-five",
    element: <Layout>
      <HomeFive {...home5} />
    </Layout>,
  },
  {
    path: "/about-dark",
    element: <Layout>
      <AboutDark {...home3} />
    </Layout>,
  },
  {
    path: "/about-us",
    element: <Layout>
      <AboutUs />
    </Layout>,
  },
  {
    path: "/about-light",
    element: <Layout>
      <AboutLight {...home4} />
    </Layout>,
  },
  {
    path: "/blog-dark-sidebar",
    element: <Layout>
      <BlogDarkSidebar {...home3} />
    </Layout>,
  },
  {
    path: "/blog-dark",
    element: <Layout>
      <BlogDark {...home3} />
    </Layout>,
  },
  {
    path: "/blog-light-sidebar",
    element: <Layout>
      <BlogLightSidebar {...home4} />
    </Layout>,
  },
  {
    path: "/blog-light",
    element: <Layout>
      <BlogLight {...home4} />
    </Layout>,
  },
  {
    path: "/blog",
    element: <Layout>
      <Blog />
    </Layout>,
  },
  {
    path: "/career",
    element: <Layout>
      <Career />
    </Layout>,
  },
  {
    path: "/coming-soon",
    element: <Layout>
      <ComingSoon />
    </Layout>,
  },
  {
    path: "/contact-dark",
    element: <Layout>
      <ContactDark {...home3} />
    </Layout>,
  },
  {
    path: "/contact-light",
    element: <Layout>
      <ContactLight {...home3} />
    </Layout>,
  },
  {
    path: "/contact",
    element: <Layout>
      <Contact />
    </Layout>,
  },
  {
    path: "/faq",
    element: <Layout>
      <Faq />
    </Layout>,
  },
  {
    path: "/portfolio-one",
    element: <Layout>
      <PortfolioOne />
    </Layout>,
  },
  {
    path: "/portfolio-two",
    element: <Layout>
      <PortfolioTwo />
    </Layout>,
  },
  {
    path: "/portfolio-three",
    element: <Layout>
      <PortfolioThree/>
    </Layout>,
  },
  {
    path: "/pricing-one",
    element: <Layout>
      <PricingOne/>
    </Layout>,
  },
  {
    path: "/pricing-two",
    element: <Layout>
      <PricingTwo/>
    </Layout>,
  },
  {
    path: "/service",
    element: <Layout>
      <Service/>
    </Layout>,
  },
  {
    path: "/single-blog-dark",
    element: <Layout>
      <SingleBlogDark {...home3}/>
    </Layout>,
  },
  {
    path: "/single-blog-light",
    element: <Layout>
      <SingleBlogLight/>
    </Layout>,
  },
  {
    path: "/single-career",
    element: <Layout>
      <SingleCareer/>
    </Layout>,
  },
  {
    path: "/single-portfolio",
    element: <Layout>
      <SinglePortFolio/>
    </Layout>,
  },
  {
    path: "/single-service",
    element: <Layout>
      <SingleService/>
    </Layout>,
  },
  {
    path: "/single-team",
    element: <Layout>
      <SingleTeam/>
    </Layout>,
  },
  {
  path: "/team-dark",
  element: <Layout>
    <TeamDark {...home3}/>
  </Layout>,
  },
  {
  path: "/team-light",
  element: <Layout>
    <TeamLight {...home4}/>
  </Layout>,
  },
  {
  path: "/team",
  element: <Layout>
    <Team/>
  </Layout>,
  },
  {
  path: "/testomonial",
  element: <Layout>
    <Testimonial/>
  </Layout>,
  },
  {
    path: "*",
    element: <Layout>
      <ErrorPage header={"six"} footer={"one"} />
    </Layout>,
  }
]);